import { Security_URL } from '@/helpers/URL'

const SecurityControllerEndpoint = path => {
  if (!path) {
    throw new Error('Path is required')
  }
  return `${Security_URL}${path}`
}
//POST Endpoints

export const UPDATE_USER = SecurityControllerEndpoint('updateUser')
export const UPDATE_USER_ACCESS = SecurityControllerEndpoint('updateUserAccess')
export const UPDATE_SELECTED_LOCATION = SecurityControllerEndpoint('updateSelectedLocation')
export const UPDATE_PRODUCT_REGISTRATION = SecurityControllerEndpoint('updateProductRegistration')
export const UPDATE_APP_ACCESS_TEMPLATE = SecurityControllerEndpoint('updateAppAccessTemplate')
export const GET_APP_USER_AUDIT_FOR_USER = SecurityControllerEndpoint('getAppUserAuditForUser')
export const CREATE_USER = SecurityControllerEndpoint('createUser')
export const CHANGE_PASSWORD = SecurityControllerEndpoint('changePassword')
export const AUTHENTICATE_USER = SecurityControllerEndpoint('authenticateUser')
export const ADD_PRODUCT_REGISTRATION = SecurityControllerEndpoint('addProductRegistration')
export const ADD_APP_ACCESS_TEMPLATE = SecurityControllerEndpoint('addAppAccessTemplate')
export const UPDATE_ACCESS_MODULE = SecurityControllerEndpoint('UpdateAccessModule')

//GET Endpoints
export const IS_PRODUCT_REGISTERED = SecurityControllerEndpoint('isProductRegistered')
export const GET_ALL_PRODUCT_REGISTRATIONS = SecurityControllerEndpoint(
  'getAllProductRegistrations'
)

export const GET_PRODUCT_REGISTRATION = SecurityControllerEndpoint('getProductRegistration')

export const GET_ALL_USERS = SecurityControllerEndpoint('getAllUsers')
export const GET_ALL_APP_ACCESS_TEMPLATE = SecurityControllerEndpoint('getAllAppAccessTemplates')
export const GET_ALL_PRODUCTS_SUMMARY = SecurityControllerEndpoint('getAllProductsSummary')
export const GET_EDIT_REASONS = SecurityControllerEndpoint('getEditReasons')
